import { alfred } from '@toggle/toggle';
import { z } from 'zod';

import { wretchRequest } from '~/utils/api-fetch/apiFetch';

export type FetchContentQuestionsResponse = z.infer<
  typeof alfred.contentQuestions.getQuestions.schema
>;

export const fetchContentQuestions = (signal?: AbortSignal) =>
  wretchRequest<FetchContentQuestionsResponse>(
    alfred.contentQuestions.getQuestions.path,
    {
      method: 'get',
      schema: alfred.contentQuestions.getQuestions.schema,
      signal,
    }
  );
